export default {
    OBJECT_NAME: "Название объекта",
    METHOD_NAME: "Название метода",
    GROUP_NAME: "Название группы",
    GROUP_ID: "ID группы",
    ICON: "Иконка",
    DESCRIPTION: "Описание"
};
